import React, { Component } from 'react';
import { connect } from 'react-redux';
import TradeDetailsView from './TradeDetails.view';

import enums from '../../../../constants/enums';

export class TradeDetailsContainer extends Component {

  constructor(props){
    super(props);
    this.state = {
      disputeMessageMessages: enums.disputeMessageMessages,
      tradeStatus: enums.tradeStatus,
      giftcardLinks: enums.giftcardLinks,
      paymentTypes: enums.giftcards,
      salesChannelTypes: enums.salesChannelTypes,
      salesChannelStatus: enums.salesChannelStatus,
      paymentStatus: this.getPaymentStatus(props),
      chatInputValue: '',
      disputeMessageInputValue: '',
      reason_type: '',
    };
    this.addPayment = this.addPayment.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.releaseFunds = this.releaseFunds.bind(this);
    this.markAsPaid = this.markAsPaid.bind(this);

    this.submitForm = this.submitForm.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.onChatChange = this.onChatChange.bind(this);
    this.setChatText = this.setChatText.bind(this);
    this.onDisputeMessageChange = this.onDisputeMessageChange.bind(this);
    this.onDisputeMessageIdChange = this.onDisputeMessageIdChange.bind(this);
    this.setDisputeMessageText = this.setDisputeMessageText.bind(this);
    this.chatSubmit = this.chatSubmit.bind(this);
    this.disputeMessageSubmit = this.disputeMessageSubmit.bind(this);
    this.toggleDisputeModal = this.toggleDisputeModal.bind(this);
    this.toggleClientModal = this.toggleClientModal.bind(this);
    this.refreshTrade = this.refreshTrade.bind(this);
    this.submitFileUpload = this.submitFileUpload.bind(this);
    this.toggleFlagTrade = this.toggleFlagTrade.bind(this);
    this.toggleHelpRequest = this.toggleHelpRequest.bind(this);
    this.cancel = this.cancel.bind(this);
    this.toggleReleaseModal = this.toggleReleaseModal.bind(this);
    this.setChecklistMode = this.setChecklistMode.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(this.props.context !== nextProps.context){
      this.setState({
        paymentStatus: this.getPaymentStatus(nextProps),
      });
    }
  }

  getPaymentStatus(props){
    const { context } = props;
    let paymentStatus = enums.paymentStatus;
    if(context === 'open'){
      paymentStatus = paymentStatus.filter(status=> status.openTradeAvailable);
    }
    return paymentStatus;
  }

  chatSubmit(){
    const { dispatch, trade } = this.props;
    const { chatInputValue } = this. state;
    dispatch({
      $global: true,
      type: 'TRADE_MESSAGE_SUBMIT',
      payload: {
        tradeId: trade.tradeId,
        message: chatInputValue,
      }
    });
    this.setState({
      chatInputValue: '',
    });
  }

  setChatText(text){
    this.setState({
      chatInputValue: text,
    });
  }

  onChatChange(value){
    this.setState({
      chatInputValue: value,
    });
  }

  disputeMessageSubmit(){
    const { dispatch, trade } = this.props;
    const { disputeMessageInputValue, reason_type } = this.state;
    dispatch({
      $global: true,
      type: 'TRADE_DISPUTE_MESSAGE_SUBMIT',
      payload: {
        tradeId: trade.tradeId,
        message: disputeMessageInputValue,
        reason_type,
      }
    });
    this.setState({
      disputeMessageInputValue: '',
      reason_type: '',
    });
  }

  setDisputeMessageText(text){
    this.setState({
      disputeMessageInputValue: text,
    });
  }

  onDisputeMessageChange(value){
    this.setState({
      disputeMessageInputValue: value,
    });
  }

  onDisputeMessageIdChange(value){
    this.setState({
      reason_type: value,
    });
  }

  toggleEdit(){
    const { trade, dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_TRADE_EDIT',
    });
    this.setState({
      formState: {
        data: trade,
      }
    });
  }

  setChecklistMode(checklistMode) {
    const { dispatch } = this.props;

    dispatch({
      $global: true,
      type: 'SET_CHECKLIST_MODE',
      payload: {
        checklistMode,
      }
    })
  }

  onFormUpdate(formState, actions) {
    this.setState({
      formState: {
        ...formState,
        data: {
          ...formState.data,
          payments: formState.data.payments.map(payment=>{
            let value = payment.value;
            if (['split', 'alreadyRedeemed', 'receiptIssue'].indexOf(payment.status) > -1) {
              value = 0;
            }

            return {
              ...payment,
              value,
              code: (payment.code || '').replace(/[-_ ]/g, '').toUpperCase(),
              pin: (payment.pin || '').replace(/[-_ ]/g, '').toUpperCase(),
            }
          })
        }
      }
    });
  }

  toggleReleaseModal(show) {
    this.setState({
      releaseModalActive: show,
    });
  }

  releaseFunds(info){
    const { dispatch, trade } = this.props;
    const giftcardOptions = enums.giftcardsMap[trade.type] || {};
    if (!info && giftcardOptions.releaseModal) {
      this.setState({
        releaseModalActive: true,
      });
    } else {
      this.setState({
        releaseModalActive: false,
      });
      if (this.confirm('Are you sure you want to release the funds? This action will result in paying for the gift card.')){
        dispatch({ type: 'TRADE_RELEASING_FUNDS' });
        dispatch({
          $global: true,
          type: 'TRADE_RELEASE_FUNDS',
          payload: {
            tradeId: trade.tradeId,
            info,
          }
        });
      }
    }
  }

  markAsPaid(){
    const { dispatch, trade } = this.props;
    if(this.confirm('Are you sure you want to mark as paid?')){
      dispatch({ type: 'TRADE_RELEASING_FUNDS' });
      dispatch({
        $global: true,
        type: 'TRADE_MARK_AS_PAID',
        payload: {
          tradeId: trade.tradeId,
        }
      });
    }
  }

  cancel(){
    const { dispatch, trade } = this.props;
    if (this.confirm('Are you sure you have not entered any card information?')) {
      if (confirm('Are you sure you want to cancel the trade?')) {
        dispatch({ type: 'TRADE_CANCELING' });
        dispatch({
          $global: true,
          type: 'TRADE_CANCEL',
          payload: {
            tradeId: trade.tradeId,
          }
        });
      }
    }
  }

  removeItem(key, index){
    const { formState } = this.state;
    const { data } = formState;

    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          [key]: [
            ...data[key].slice(0, index),
            ...data[key].slice(index + 1),
          ]
        }
      }
    });

  }

  addItem(key, value){
    const { formState } = this.state;
    const { data } = formState;
    this.setState({
      formState: {
        ...formState,
        data: {
          ...data,
          [key]: [
            ...data[key],
            value,
          ]
        }
      }
    });
  }

  addPayment(){
    const { paymentTypes, paymentStatus, formState } = this.state;
    const { trade } = this.props;
    const total = formState.data.payments.reduce((sum, payment)=> sum + parseFloat(payment.value), 0);
    const value = parseFloat(trade.amount) - total;
    this.addItem('payments', {
      trade_id: trade._id,
      tradeId: trade.tradeId,
      code: '',
      pin: '',
      type: paymentTypes.find(type=> type.value === trade.type) ? trade.type : paymentTypes[0].value,
      status: paymentStatus[0].value,
      value,
    });
  }

  dispatchUpdate(data){
    const { dispatch, trade, context, filtersFormState, page } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_TRADE_DETAILS',
      payload: {
        context,
        page,
        filters: filtersFormState && filtersFormState.data,
        _id: trade._id,
        tradeId: trade.tradeId,
        data,
      }
    });
  }

  updateTradeField(field, value) {
    const { dispatch, trade, context, filtersFormState, page } = this.props;
    dispatch({
      $global: true,
      type: 'UPDATE_TRADE_FIELD',
      payload: {
        context,
        page,
        filters: filtersFormState && filtersFormState.data,
        tradeId: trade.tradeId,
        _id: trade._id,
        field: field,
        value: value,
      },
    });
  }

  toggleHelpRequest(){
    const { trade } = this.props;
    this.updateTradeField('helpRequested', !trade.helpRequested);
  }

  toggleFlagTrade(){
    const { trade } = this.props;
    this.updateTradeField('flagged', !trade.flagged);
  }

  submitForm(formState) {
    const { trade } = this.props;
    const { payments, trade_status } = formState.data;
    this.dispatchUpdate({
      payments,
      trade_status: trade_status || trade.trade_status,
    });
  }

  submitFileUpload({ file, clearInput }) {
    const { dispatch } = this.props;

    dispatch({
      $global: true,
      type: 'SUBMIT_FILE_UPLOAD',
      payload: {
        tradeId: this.props.trade.tradeId,
        data: {
          file,
        },
        // this is a bad pattern, I should move the message text to redux state
        onComplete: (file) => {
          clearInput();
          if (!file.publicUrl) {
            alert('Image has been uploaded and sent to the trading partner.');
          } else {
            this.setState({
              chatInputValue: file.publicUrl,
            });
          }
        }
      },
    });
  }

  toggleCheckbox(prop){
    const { trade, dispatch } = this.props;
    const confirmMessage = {
      photoVerified: trade.images.length ? 'Have the required photos been uploaded?' : 'Are you sure no photo is required for this trade?',
      cardDataInserted: 'Has the card data been inserted?',
      cardDataVerified: 'Has the card data been verified?',
      cardRedeemed: 'Has the card been redeemed?',
    };
    const checked = !trade[prop];
    if((checked && this.confirm(confirmMessage[prop])) || !checked){
      this.dispatchUpdate({
        [prop]: checked,
      })
    }
  }

  confirm(message) {
    const { checklistMode } = this.props;
    if (checklistMode === 'noConfirm') {
      return true;
    }
    return confirm(message);
  }

  refreshTrade(){
    const { trade, dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'REFRESH_TRADE',
      payload: {
        tradeId: trade.tradeId,
      }
    });
  }

  toggleDisputeModal(active) {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_DISPUTE_MODAL',
      payload: {
        active,
      }
    });
  }

  toggleClientModal(active) {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_CLIENT_MODAL',
      payload: {
        active,
      }
    });
  }

  render() {
    return (<TradeDetailsView
      {...this.props}
      {...this.state}
      createTradeToken={this.createTradeToken}
      toggleCheckbox={this.toggleCheckbox}
      onChatChange={this.onChatChange}
      setChatText={this.setChatText}
      toggleClientModal={this.toggleClientModal}
      toggleDisputeModal={this.toggleDisputeModal}
      onDisputeMessageChange={this.onDisputeMessageChange}
      onDisputeMessageIdChange={this.onDisputeMessageIdChange}
      setDisputeMessageText={this.setDisputeMessageText}
      chatSubmit={this.chatSubmit}
      disputeMessageSubmit={this.disputeMessageSubmit}
      submitForm={this.submitForm}
      onFormUpdate={this.onFormUpdate}
      removeItem={this.removeItem}
      addPayment={this.addPayment}
      toggleEdit={this.toggleEdit}
      refreshTrade={this.refreshTrade}
      releaseFunds={this.releaseFunds}
      markAsPaid={this.markAsPaid}
      cancel={this.cancel}
      submitFileUpload={this.submitFileUpload}
      toggleFlagTrade={this.toggleFlagTrade}
      toggleHelpRequest={this.toggleHelpRequest}
      toggleReleaseModal={this.toggleReleaseModal}
      setChecklistMode={this.setChecklistMode}
    />);
  }

}

function mapStateToProps(state, ownProps) {
  const { editing, disputeModalActive, clientModalActive, releasing, canceling, hasSellPayments } = state.tradeDetails;
  const { checklistMode } = state.trades;
  return {
    checklistMode,
    editing,
    releasing,
    canceling,
    hasSellPayments,
    disputeModalActive,
    clientModalActive,
    trade: ownProps.trade,
    trades: ownProps.trades,
  };
}

export default connect(mapStateToProps)(TradeDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/TradeDetails.container.js